export default __webpack_public_path__ + "static/media/student.6e8dab5c.svg";